// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiDropSubscriptionTargetAction } from '../models/ApiDropSubscriptionTargetAction';
import { HttpFile } from '../http/http';

export class ApiDropSubscriptionActions {
    'actions': Array<ApiDropSubscriptionTargetAction>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "actions",
            "baseName": "actions",
            "type": "Array<ApiDropSubscriptionTargetAction>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiDropSubscriptionActions.attributeTypeMap;
    }

    public constructor() {
    }
}

